import { useContext } from 'react';
import styled, { css, useTheme } from 'styled-components';

import LINKS from '../../../../configs/links';
import { showChat } from '../../../../utils/liveChat';
import Button from '../../../common/base/Button';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { UserContext } from '../../../contexts/UserContext';
import { handleLogout } from '../Nav/NavFooter';

const StyledOnboardingNav = styled.div(
  ({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 ${theme.spacing(6)};
    height: 52px;
    z-index: 2;
    border-bottom: ${theme.border};
    background-color: ${theme.colors.surface.base.background};

    a {
      height: fit-content;
      height: 16px;
    }

    @media only screen and (max-width: 900px) {
      padding: 0 ${theme.spacing(4)};
    }
  `,
);

const OnboardingNav = ({ sign_out_action }: { sign_out_action?: React.ReactElement }) => {
  const { HookdeckAPI } = useContext(GlobalContext);
  const { user } = useContext(UserContext);
  const theme = useTheme();

  return (
    <StyledOnboardingNav>
      <a href={LINKS.landing}>
        <img src={`/images/logo-colored-${theme.mode}.svg`} height="16" />
      </a>
      <Div flex={{ justify: 'end', gap: 1 }}>
        <Button ghost icon="chat" onClick={showChat}>
          Help
        </Button>
        {sign_out_action ||
          (user && (
            <Button ghost icon="logout" onClick={() => handleLogout(HookdeckAPI)}>
              Sign out
            </Button>
          ))}
      </Div>
    </StyledOnboardingNav>
  );
};

export default OnboardingNav;
